import { render, staticRenderFns } from "./MainLayout.vue?vue&type=template&id=04546268&scoped=true&"
import script from "./MainLayout.vue?vue&type=script&lang=ts&"
export * from "./MainLayout.vue?vue&type=script&lang=ts&"
import style0 from "./MainLayout.vue?vue&type=style&index=0&id=04546268&prod&lang=less&"
import style1 from "./MainLayout.vue?vue&type=style&index=1&id=04546268&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04546268",
  null
  
)

export default component.exports